import MyBread from "../../components/Breadcrumbs";
import React, {
  Fragment,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import MaterialTable from "material-table";
import { ThemeProvider, createTheme } from "@mui/material";
import { useModal } from "react-hooks-use-modal";
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from "../../hooks/use-auth";
import axios from "axios";
import IdSearchButtonWithParent from "../../components/IdSearchButtonWithParent";
import config from "config";
import { removeKeyWithValue, formatNumberToDigits, Time } from "utils";
import IdSearchButton from "components/IdSearchButton";
import {
  Wrapper,
  PageTitle,
  CreateNew,
  ModalStyle,
  FormLabel,
  FormInput,
  FormLabelInputWrapper,
  ModalTitle,
  ModalForm,
  ModalSubmit,
  LoadingContainer,
  ModalClose,
  DivMargin,
} from "styles/styles";
import { CircularProgress } from "@mui/material";

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ChildProps {
  data: ChildDataProps[];
  parentData: ParentDataProps[];
  setIsChildDataInsert: Dispatch<SetStateAction<boolean>>;
  selectedId: number;
}

interface ParentDataProps {
  records_order_id: number;
  customer_id: number;
  customer_display_id: string;
  customer_name: string;
  customer_branch_id: number;
  customer_branch_display_id: string;
  customer_branch_name: string;
  charged_user_id: number;
  charged_user_display_id: string;
  charged_user_name: string;
  memo: string;
  display_id: string;
  [key: string]: string | number;
}

interface ChildDataProps {
  records_product_number_id: number;
  records_order_id: number;
  serial_number: string;
  serial_number_branch: string;
  product_number_id: number;
  product_number_display_id: string;
  product_number_branch_id: number;
  product_number_branch_display_id: string;
  name: string;
  standard_processes_id: number;
  standard_processes_display_id: string;
  charged_user_id: number;
  charged_user_display_id: string;
  charged_user_name: string;
  order_number: string;
  order_date: string;
  customer_deadline: string;
  internal_deadline: string;
  estimated_shipping_date: string;
  inventory_reservation: string;
  volume: number;
  unit_price: string;
  total_price: number;
  memo: string;
  [key: string]: string | number;
}

const Parent = ({
  data,
  selectedId,
  setSelectedId,
  setIsParentDataInsert,
}: ParentProps) => {
  const auth = useAuth();
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [modalTitle, setModalTitle] = React.useState("");
  const [Modal, open, close, isOpen] = useModal("root", {
    preventScroll: true,
  });
  const {
    reset,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (
    submitData: ParentDataProps
  ) => {
    let alertList: any[] = [];
    const requiredFields = parentArray
      .filter((obj) => obj.required === true)
      .map((obj) => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === "") {
        alertList.push(key);
      }
    });
    if (alertList.length) {
      let text = "";
      parentArray.forEach((item) => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== "") {
        alert(text);
        throw new Error("必須項目が未入力です");
      }
    }
    submitData = removeKeyWithValue(submitData, "");
    const branchData = {
      customer_id: submitData.customer_id,
      customer_display_id: submitData.customer_display_id,
      customer_name: submitData.customer_name,
      customer_branch_id: submitData.customer_branch_id,
      customer_branch_display_id: submitData.customer_branch_display_id,
      customer_branch_name: submitData.customer_branch_name,
      charged_user_id: submitData.charged_user_id,
      charged_user_display_id: submitData.charged_user_display_id,
      charged_user_name: submitData.charged_user_name,
      memo: submitData.memo,
      display_id: submitData.display_id,
    };
    try {
      setIsSubmitDisable(true);
      if (!selectedId) {
        await axios.post(
          `/v0/factories/${auth.factoryId}/records-orders`,
          branchData,
          {
            headers: auth.authorizationHeader,
          }
        );
        window.alert("登録が完了しました");
      } else {
        await axios.patch(
          `/v0/factories/${auth.factoryId}/records-orders`,
          branchData,
          {
            headers: auth.authorizationHeader,
            params: { id: selectedId },
          }
        );
        window.alert("変更が完了しました");
      }
      close();
      setIsParentDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [
    { title: "", field: "records_order_id", default: 0 },
    {
      title: "受注管理No",
      field: "display_id",
      default: 1,
      type: "alphanumeric",
      required: true,
    },
    { title: "", field: "customer_id" },
    {
      title: "得意先ID",
      field: "customer_display_id",
      default: "",
      required: true,
      disable: true,
    },
    {
      title: "得意先名",
      field: "customer_name",
      default: "",
      required: true,
      disable: true,
    },
    { title: "", field: "customer_branch_id" },
    {
      title: "得意先枝番",
      field: "customer_branch_display_id",
      default: "",
      required: true,
      disable: true,
    },
    {
      title: "得意先担当者名",
      field: "customer_branch_name",
      default: "",
      search: "customers",
      required: true,
      disable: true,
    },
    { title: "", field: "charged_user_id" },
    {
      title: "担当者ID",
      field: "charged_user_display_id",
      default: "",
      disable: true,
      required: true,
    },
    {
      title: "担当者名",
      field: "charged_user_name",
      default: "",
      disable: true,
      required: true,
      search: "users",
    },
    { title: "工程完了数", field: "completed_number" },
    { title: "工程未完了数", field: "not_completed_number" },
    { title: "メモ", field: "memo", default: "メモです", type: "text" },
  ];
  const PAGE_TITLE = "受注一覧";
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      });
    }
  }

  const [selectedCustomerContents, setSelectedCustomerContents] =
    useState<any>("");
  const [selectedCustomerBranchContents, setSelectedCustomerBranchContents] =
    useState<any>("");

  useEffect(() => {
    setValue("customer_id", selectedCustomerContents.customer_id);
    setValue("customer_display_id", selectedCustomerContents.display_id);
    setValue("customer_name", selectedCustomerContents.name);
    setValue(
      "customer_branch_id",
      selectedCustomerBranchContents.customer_branch_id
    );
    setValue(
      "customer_branch_display_id",
      selectedCustomerBranchContents.display_id
    );
    setValue("customer_branch_name", selectedCustomerBranchContents.name);
  }, [selectedCustomerContents, selectedCustomerBranchContents]);

  const [selectedUserContents, setSelectedUserContents] = useState<any>("");

  useEffect(() => {
    setValue("charged_user_id", selectedUserContents.user_id);
    setValue("charged_user_display_id", selectedUserContents.display_id);
    setValue("charged_user_name", selectedUserContents.name);
  }, [selectedUserContents]);

  const listItems = parentArray.map((element: any, index) => {
    if (
      element.title &&
      element.field !== "not_completed_number" &&
      element.field !== "completed_number"
    ) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput
              {...register(element.field)}
              {...(element.type && {
                type: config.inputErrorMessage[element.type].type,
              })}
              {...(element.type && {
                placeholder: config.inputErrorMessage[element.type].placeholder,
              })}
              {...(element.type && {
                pattern: config.inputErrorMessage[element.type].pattern,
              })}
              {...(element.type && {
                title: config.inputErrorMessage[element.type].title,
              })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && {
                maxLength: config.inputErrorMessage[element.type].maxLength,
              })}
              {...(element.type === "number" && {
                max: config.inputErrorMessage[element.type].max,
              })}
              {...(element.field.includes("branch") && { max: 99 })}
            />
            {element.search === "customers" ? (
              <IdSearchButtonWithParent
                search={element.search}
                setSelectedContents={setSelectedCustomerContents}
                setSelectedBranchContents={setSelectedCustomerBranchContents}
              />
            ) : null}
            {element.search === "users" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedUserContents}
              />
            ) : (
              <></>
            )}
          </FormLabelInputWrapper>
        </Fragment>
      );
    }
  });

  //カラムなど生成ここまで

  const [pageSize, setPageSize] = React.useState(5);
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);

  //IDから既存の値を呼び出し
  async function setModalValue(records_order_id: number) {
    if (!records_order_id) {
      const orderCount: any = await axios.get(
        `/v0/factories/${auth.factoryId}/records-orders`,
        {
          headers: auth.authorizationHeader,
          params: { type: "count" },
        }
      );
      defaultObj.display_id = parseInt(orderCount.data[0].record_count) + 1;
      reset(defaultObj);
      setModalTitle("新規作成");
    } else {
      //データの取得axios
      setSelectedId(records_order_id);
      const result: any = await axios.get(
        `/v0/factories/${auth.factoryId}/records-orders`,
        {
          headers: auth.authorizationHeader,
          params: { id: records_order_id },
        }
      );
      reset(result.data[0]);
      setModalTitle("編集");
    }
  }

  const createNew = async () => {
    setSelectedId(0);
    await setModalValue(0);
    open();
  };

  return (
    <>
      <CreateNew onClick={createNew}>新規作成</CreateNew>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: "edit",
              tooltip: "編集する",
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.records_order_id);
                  open();
                } catch (error) {
                  console.log(error);
                }
              },
            },
            {
              icon: "delete",
              tooltip: "削除する",
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(
                  `${rowData.display_id}を削除しますか？`
                );
                if (result) {
                  try {
                    await axios.delete(
                      `/v0/factories/${auth.factoryId}/records-orders`,
                      {
                        headers: auth.authorizationHeader,
                        params: { id: rowData.records_order_id },
                      }
                    );
                    setIsParentDataInsert(true);
                    setSelectedId(0);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              },
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: "nowrap" },
            rowStyle: (rowData) => ({
              overflowWrap: "break-word",
              backgroundColor:
                selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
            }),
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
            setSelectedId(rowData.records_order_id);
            setSelectedRow(rowData.tableData.id);
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  );
};

const Child = ({
  data,
  parentData,
  setIsChildDataInsert,
  selectedId,
}: ChildProps) => {
  const auth = useAuth();
  const [selectedBranch, setSelectedBranch] = React.useState(0);
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [pageSize, setPageSize] = React.useState(5);
  const [modalTitle, setModalTitle] = React.useState("");
  const [Modal, open, close, isOpen] = useModal("root", {
    preventScroll: true,
  });
  const {
    reset,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<ChildDataProps>();
  const onSubmit: SubmitHandler<ChildDataProps> = async (
    submitData: ChildDataProps
  ) => {
    let alertList: any[] = [];
    const requiredFields = parentArray
      .filter((obj) => obj.required === true)
      .map((obj) => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === "") {
        alertList.push(key);
      }
    });
    if (alertList.length) {
      let text = "";
      parentArray.forEach((item) => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== "") {
        alert(text);
        throw new Error("必須項目が未入力です");
      }
    }
    submitData = removeKeyWithValue(submitData, "");
    submitData = removeKeyWithValue(submitData, null);
    const branchData = {
      serial_number: submitData.serial_number,
      serial_number_branch: submitData.serial_number_branch,
      product_number_id: submitData.product_number_id,
      product_number_display_id: submitData.product_number_display_id,
      product_number_branch_id: submitData.product_number_branch_id,
      product_number_branch_display_id:
        submitData.product_number_branch_display_id,
      name: submitData.name,
      standard_processes_id: submitData.standard_processes_id,
      charged_user_id: submitData.charged_user_id,
      charged_user_display_id: submitData.charged_user_display_id,
      charged_user_name: submitData.charged_user_name,
      order_number: submitData.order_number,
      order_date: submitData.order_date,
      customer_deadline: submitData.customer_deadline,
      internal_deadline: submitData.internal_deadline,
      estimated_shipping_date: submitData.estimated_shipping_date,
      inventory_reservation: submitData.inventory_reservation,
      volume: submitData.volume,
      unit_price: submitData.unit_price,
      total_price: submitData.total_price,
      memo: submitData.memo,
    };
    try {
      setIsSubmitDisable(true);
      if (!selectedBranch) {
        await axios.post(
          `/v0/records-orders/${selectedId}/records-product-numbers`,
          branchData,
          {
            headers: auth.authorizationHeader,
            params: { factory_id: auth.factoryId },
          }
        );
        window.alert("登録が完了しました");
      } else {
        await axios.patch(
          `/v0/records-orders/${selectedId}/records-product-numbers`,
          branchData,
          {
            headers: auth.authorizationHeader,
            params: {
              selected_branch: selectedBranch,
              factory_id: auth.factoryId,
            },
          }
        );
        window.alert("変更が完了しました");
      }
      close();
      setIsChildDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [
    { title: "", field: "records_product_number_id" },
    {
      title: "製番",
      field: "serial_number",
      type: "alphanumeric",
      required: true,
    },
    {
      title: "製番_枝番",
      field: "serial_number_branch",
      default: "00",
      type: "branch",
      required: true,
    },
    { title: "", field: "product_number_id" },
    {
      title: "品番ID",
      field: "product_number_display_id",
      default: "",
      required: true,
      disable: true,
    },
    { title: "", field: "product_number_branch_id" },
    {
      title: "品番_枝番",
      field: "product_number_branch_display_id",
      default: "",
      search: "product-numbers",
      required: true,
      disable: true,
    },
    {
      title: "品名",
      field: "name",
      default: "品名",
      type: "text",
      required: true,
    },
    { title: "", field: "standard_processes_id" },
    {
      title: "標準工程枝番",
      field: "standard_processes_display_id",
      default: "",
      disable: true,
      search: "standard-processes",
    },
    { title: "", field: "charged_user_id" },
    {
      title: "担当者ID",
      field: "charged_user_display_id",
      disable: true,
      required: true,
      default: "",
    },
    {
      title: "担当者名",
      field: "charged_user_name",
      disable: true,
      required: true,
      search: "users",
      default: "",
    },
    { title: "工程完了数", field: "completed_number" },
    { title: "工程未完了数", field: "not_completed_number" },
    { title: "受注数", field: "order_number", default: 0, type: "number" },
    {
      title: "受注日",
      field: "order_date",
      default: Time.format(new Date(), "YYYY-MM-DD"),
      type: "date",
    },
    {
      title: "希望納期",
      field: "customer_deadline",
      default: Time.format(new Date(), "YYYY-MM-DD"),
      type: "date",
    },
    {
      title: "目標納期",
      field: "internal_deadline",
      default: Time.format(new Date(), "YYYY-MM-DD"),
      type: "date",
    },
    {
      title: "出荷予定日",
      field: "estimated_shipping_date",
      default: Time.format(new Date(), "YYYY-MM-DD"),
      type: "date",
    },
    {
      title: "在庫引当数量",
      field: "inventory_reservation",
      default: 0,
      type: "number",
    },
    { title: "製作数量", field: "volume", default: 0, type: "number" },
    { title: "単価", field: "unit_price", default: 0, type: "number" },
    { title: "金額", field: "total_price", default: 0, type: "number" },
    { title: "メモ", field: "memo", default: "メモ", type: "text" },
  ];
  const PAGE_TITLE = "製番品番";
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title && element.field !== "standard_processes_display_id") {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      });
    }
  }

  const [selectedProductNumberContents, setSelectedProductNumberContents] =
    useState<any>("");
  const [
    selectedProductNumberBranchContents,
    setSelectedProductNumberBranchContents,
  ] = useState<any>("");

  useEffect(() => {
    setValue(
      "product_number_id",
      selectedProductNumberContents.product_number_id
    );
    setValue(
      "product_number_display_id",
      selectedProductNumberContents.display_id
    );
    setValue(
      "product_number_branch_id",
      selectedProductNumberBranchContents.product_number_branch_id
    );
    setValue(
      "product_number_branch_display_id",
      selectedProductNumberBranchContents.display_id
    );
    setValue("name", selectedProductNumberBranchContents.name);
    setValue(
      "standard_processes_id",
      selectedProductNumberBranchContents.standard_processes_id
    );
    setValue(
      "standard_processes_display_id",
      selectedProductNumberBranchContents.standard_processes_display_id
    );
  }, [selectedProductNumberContents, selectedProductNumberBranchContents]);

  const [selectedUserContents, setSelectedUserContents] = useState<any>("");

  useEffect(() => {
    setValue("charged_user_id", selectedUserContents.user_id);
    setValue("charged_user_display_id", selectedUserContents.display_id);
    setValue("charged_user_name", selectedUserContents.name);
  }, [selectedUserContents]);

  const [
    selectedStandardProcessesContents,
    setSelectedStandardProcessesContents,
  ] = useState<any>("");

  useEffect(() => {
    setValue(
      "standard_processes_id",
      selectedStandardProcessesContents.standard_process_id
    );
    setValue(
      "standard_processes_display_id",
      selectedStandardProcessesContents.display_id
    );
  }, [selectedStandardProcessesContents]);

  const listItems = parentArray.map((element: any, index) => {
    if (
      element.title &&
      element.field !== "not_completed_number" &&
      element.field !== "completed_number" &&
      !(selectedBranch && element.field === "standard_processes_display_id")
    ) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput
              {...register(element.field)}
              {...(element.type && {
                type: config.inputErrorMessage[element.type].type,
              })}
              {...(element.type && {
                placeholder: config.inputErrorMessage[element.type].placeholder,
              })}
              {...(element.type && {
                pattern: config.inputErrorMessage[element.type].pattern,
              })}
              {...(element.type && {
                title: config.inputErrorMessage[element.type].title,
              })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && {
                maxLength: config.inputErrorMessage[element.type].maxLength,
              })}
              {...(element.type === "number" && {
                max: config.inputErrorMessage[element.type].max,
              })}
            />
            {element.search === "product-numbers" ? (
              <IdSearchButtonWithParent
                search={element.search}
                setSelectedContents={setSelectedProductNumberContents}
                setSelectedBranchContents={
                  setSelectedProductNumberBranchContents
                }
              />
            ) : (
              <></>
            )}
            {element.search === "users" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedUserContents}
              />
            ) : (
              <></>
            )}
            {element.search === "standard-processes" ? (
              <IdSearchButton
                search={element.search}
                setSelectedContents={setSelectedStandardProcessesContents}
              />
            ) : (
              <></>
            )}
          </FormLabelInputWrapper>
        </Fragment>
      );
    }
  });

  //カラムなど生成ここまで

  const defaultMaterialTheme = createTheme();

  /* 出荷予定日の自動入力 */
  const [deliveryDate, setDeliveryDate] = React.useState(0);
  const currentData = parentData.filter(
    (item: { [key: string]: any }) =>
      parseInt(item["records_order_id"]) === selectedId
  );
  const customer_deadline = watch("customer_deadline");
  useEffect(() => {
    if (customer_deadline) {
      setValue(
        "estimated_shipping_date",
        Time.subtractDaysFromDate(customer_deadline, deliveryDate)
      );
      setValue("internal_deadline", customer_deadline);
    }
  }, [customer_deadline]);

  /* 製作数量を自動入力 */
  const order_number: string = watch("order_number");
  const inventory_reservation: string = watch("inventory_reservation");
  useEffect(() => {
    let currentOrderNumber: string = order_number ? order_number : "0";
    let currentInventoryReservation: string = inventory_reservation
      ? inventory_reservation
      : "0";
    let currentVolume =
      parseInt(currentOrderNumber) - parseInt(currentInventoryReservation);
    setValue("volume", currentVolume > 0 ? currentVolume : 0);
  }, [order_number, inventory_reservation]);

  const unit_price: string = watch("unit_price");
  useEffect(() => {
    if (order_number && unit_price) {
      setValue("total_price", parseInt(order_number) * parseInt(unit_price));
    }
  }, [order_number, unit_price]);

  //IDから既存の値を呼び出し
  async function setModalValue(records_product_number_id: number) {
    const deliveryDate: any = await axios.get(
      `/v0/factories/${auth.factoryId}/customers`,
      {
        headers: auth.authorizationHeader,
        params: {
          type: "delivery_date",
          id: currentData[0].customer_id,
        },
      }
    );
    setDeliveryDate(deliveryDate.data[0].delivery_date);
    if (!records_product_number_id) {
      setSelectedBranch(0);
      const currentData = parentData.filter(
        (item: { [key: string]: any }) =>
          parseInt(item["records_order_id"]) === selectedId
      );
      if (currentData[0].shared_order_number) {
        defaultObj.order_number = currentData[0].shared_order_number;
      }
      if (currentData[0].shared_internal_deadline) {
        defaultObj.customer_deadline = currentData[0].shared_internal_deadline;
      }
      const productNumberCount: any = await axios.get(
        `/v0/records-orders/${selectedId}/records-product-numbers`,
        {
          headers: auth.authorizationHeader,
          params: {
            type: "count",
            factory_id: auth.factoryId,
          },
        }
      );
      const currentDate = new Date();
      const year = currentDate.getFullYear().toString().slice(-2);
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      defaultObj.serial_number = `${year}${month}-${formatNumberToDigits(
        parseInt(productNumberCount.data[0].product_number_count) + 1,
        4
      )}`;
      reset(defaultObj);
      setModalTitle("新規作成");
    } else {
      //データの取得axios
      setSelectedBranch(records_product_number_id);
      const result: any = await axios.get(
        `/v0/records-orders/${selectedId}/records-product-numbers`,
        {
          headers: auth.authorizationHeader,
          params: {
            selected_branch: records_product_number_id,
            factory_id: auth.factoryId,
          },
        }
      );
      reset(result.data[0]);
      setModalTitle("編集");
    }
  }

  const createNew = async () => {
    await setModalValue(0);
    open();
  };

  return (
    <>
      {selectedId === 0 ? (
        ""
      ) : (
        <CreateNew onClick={createNew}>新規作成</CreateNew>
      )}
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: "edit",
              tooltip: "編集する",
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.records_product_number_id);
                  open();
                } catch (error) {
                  console.log(error);
                }
              },
            },
            {
              icon: "delete",
              tooltip: "削除する",
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(
                  `${rowData.serial_number}を削除しますか？`
                );
                if (result) {
                  try {
                    await axios.delete(
                      `/v0/records-orders/${selectedId}/records-product-numbers`,
                      {
                        headers: auth.authorizationHeader,
                        params: {
                          selected_branch: rowData.records_product_number_id,
                          factory_id: auth.factoryId,
                        },
                      }
                    );
                    setIsChildDataInsert(true);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              },
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: "nowrap" },
            rowStyle: { overflowWrap: "break-word" },
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  );
};

export default function Orders() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [isChildDataInsert, setIsChildDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [childData, setChildData] = useState<ChildDataProps[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);

  useEffect(() => {
    try {
      axios
        .get(`/v0/factories/${auth.factoryId}/records-orders`, {
          headers: auth.authorizationHeader,
        })
        .then((res: any) => {
          if (res.data.length) {
            setParentData(res.data);
          } else {
            setParentData([]);
          }
          setIsParentDataInsert(false);
        });
    } catch (err) {
      console.log(err);
    }
  }, [auth, isParentDataInsert]);

  useEffect(() => {
    if (selectedId === 0) {
      setChildData([]);
    } else {
      try {
        axios
          .get(`/v0/records-orders/${selectedId}/records-product-numbers`, {
            headers: auth.authorizationHeader,
            params: {
              factory_id: auth.factoryId,
            },
          })
          .then((res: any) => {
            if (res.data.length) {
              setChildData(res.data);
            } else {
              setChildData([]);
            }
            setIsChildDataInsert(false);
          });
      } catch (err) {
        console.log(err);
      }
    }
  }, [auth, selectedId, isChildDataInsert]);

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>受注一覧</PageTitle>
        <Parent
          data={parentData}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          setIsParentDataInsert={setIsParentDataInsert}
        />
        <DivMargin></DivMargin>
        <Child
          data={childData}
          parentData={parentData}
          selectedId={selectedId}
          setIsChildDataInsert={setIsChildDataInsert}
        />
      </Wrapper>
    </>
  );
}
